import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import { hasOriginalData, isUpdate } from "../utils";

const defaultStrings = {
  passwordConfirm: "Confirmer le mot de passe",
  notSameError: "Les 2 mots de passes doivent être identiques"
};

export function formatData(value, format) {
  if (!format || !value) return value;
  switch (format) {
    case "uppercase":
      return value.toUpperCase();
    case "lowerCase":
      return value.toLowerCase();
  }
}

export default class PasswordField extends PureComponent {
  static defaultProps = {
    // inputType: "text",
    value: "",
    required: false
  };

  getStrings() {
    return { ...defaultStrings, ...this.props.strings };
  }

  isValid = () => {
    const { name, value, data } = this.props;
    const confirm = data[name + "Confirm"];
    console.log("confirm", confirm, value);
    return (confirm || "") === (value || "");
  };

  render() {
    const {
      id,
      name,
      value,
      data,
      disabled,
      placeholder,
      label,
      onChange
    } = this.props;
    if (disabled && !value) return null; // Hide disabled field

    const { passwordConfirm, notSameError } = this.getStrings();

    // Never required on update :-)
    const required = this.props.required && !isUpdate();
    return (
      <React.Fragment>
        <FieldContainer {...this.props} required={required}>
          <input
            id={id}
            className="af-password-field"
            name={name}
            type="password"
            placeholder={placeholder || label}
            value={value || ""}
            required={required}
            onChange={e => onChange(name, e.target.value)}
            // onChange={e => onChange(name, formatData(e.target.value, format))}
          />
        </FieldContainer>
        <FieldContainer {...this.props} label=" " required={false}>
          <input
            id={id + "Confirm"}
            className="af-password-field"
            name={name + "Confirm"}
            type="password"
            placeholder={passwordConfirm}
            value={data[name + "Confirm"] || ""}
            required={required}
            onChange={e => onChange(name + "Confirm", e.target.value)}
            // onChange={e => onChange(name, formatData(e.target.value, format))}
          />
          {!this.isValid() && (
            <div className="af-message af-message--error">{notSameError}</div>
          )}
        </FieldContainer>
      </React.Fragment>
    );
  }
}
